import { DatePipe } from '@angular/common';
import { Component, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Company, typeInterface } from 'src/app/shared/Interfaces/company';
import { Address } from 'src/app/shared/Interfaces/customer';
import { ArrayItem, Order } from 'src/app/shared/Interfaces/order';
import { ApiService } from 'src/app/shared/services/API/api.service';
import { ConnectionService } from 'src/app/shared/services/Connection/connection.service';
import { WebhookService } from 'src/app/shared/services/WeebHook/webhook.service';
import { format } from 'date-fns';
import { Location } from '@angular/common';
@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.css']
})
export class OrderDetailsComponent implements OnInit {
  private timerId: any;
  private webHookSubscription!: Subscription;
  private typeParam!: typeInterface;
  private nameCompany: string = '';
  serverDate!: Date;
  currentDate!: Date;
  numberQrCode: string = '';
  id_order: number = 0;
  id_company!: string;
  order!: Order;
  addressDelivery!: Address;
  items!: ArrayItem;
  numberOrder: string = '';
  dateOrder!: string | null;
  showTopMenu = true;
  flavors: number[] = []
  intervalId: any;
  subTotalOrder: number = 0;
  discount = 0;
  company!: Company;

  //#region Inicializadores
    constructor(
      private router: Router,
      private apiService: ApiService,
      private route: ActivatedRoute,
      private datePipe: DatePipe,
      private connection: ConnectionService,
      private webHookService: WebhookService,
      private toastr: ToastrService,
      private location: Location
      )
      {
        this.connection.nameCompany$.subscribe((newNameCompany) => {
          this.nameCompany = newNameCompany
        })
        this.connection.company$.subscribe((newCompany) =>{
          if(newCompany){
            this.id_company = newCompany.company.id_company
          }

        })

        //Resgata o nome da empresa e o parametro se é mesa
        this.connection.typeParam$.subscribe((newTypeParam) => {
          this.typeParam = newTypeParam
        })

        this.route.params.subscribe(params => {
          this.id_order = params['id_order'];
          this.getSingleOrder(this.id_order);
        })

        this.checkScreenSize();

        this.connection.company$.subscribe((data) =>{
          this.company = data;
        })

      }

    ngOnInit(): void {
      this.webHookSubscription = this.webHookService.getUpdates().subscribe(
        (content: any) => {
          if(content.type == 1)
          {
            const data = content.data
            if(this.order.id_order == data.company.id_order){
              
              this.order.orderStatus = data.webhooks[data.webhooks.length - 1].orderStatus
              this.order.events = data.webhooks
            }
          }
          else if(content.type == 5){
            const data = content.data
              if(data.id_order == this.order.id_order)
              {
                if(data.status == 1){
                  clearInterval(this.intervalId)
                  this.toastr.clear();
                  this.toastr.success('Pagamento Confirmado.', 'Sucesso', { positionClass: 'toast-top-right', timeOut: 4000});
                  this.order.orderStatus = 1;
                }
                else if(data.status == 6){
                  clearInterval(this.intervalId)
                  this.toastr.clear();
                  this.toastr.warning('Tempo de pagamento expirado.', 'Pagamento expirado.', { positionClass: 'toast-top-right', timeOut: 4000});
                  this.order.orderStatus = 10;
                }
              }
          }
        },
        (error) => {
          console.error('Erro ao receber mensagem do servidor WebHook:', error);
        }
      );

      this.getDataServer();
    }

    ngOnDestroy(): void {
      if(this.webHookSubscription) {
        this.webHookSubscription.unsubscribe();
      }
      if(this.intervalId != undefined)
      {
        clearInterval(this.intervalId);
        console.log('Intervalo finalizado', this.intervalId)
      }
    }

  //#endregion

  //#region Funções de Estilo (Style)

    @HostListener('window:resize', [])
    onWindowResize() {
      this.checkScreenSize();
    }

    //Verifica o tamanho da tela, esconde o Menu superior se necessario
    checkScreenSize(){
      if(window.innerWidth <= 846){

        this.showTopMenu = false;
      }
      else{
        this.showTopMenu = true;
      }
    }

  //#endregion

  //#region Funções de Navegação (Navigation)

    //Volta para a pagina anterior
    goback(){
      this.location.back();
    }

    //Redireciona para a pagina de historico de cashback
    goToCashback(){
      this.router.navigate([this.nameCompany, 'history-cashback']);
    }

  //#endregion

  //Faz um request puxando o pedido pelo numero dele
  private getSingleOrder(id_order: number){
    this.apiService.getSingleOrder(id_order).subscribe((data) =>{
      
      this.order = data.response.orders[0];

      console.log(this.order)

      this.numberOrder = this.order.displayId;

      this.items = this.order;

      this.subTotalOrder = this.calcSubTotal();
      
      //Caso o pedido seja para entrega
      if(this.order.customer.customerAddress)
      {
        this.addressDelivery = this.order.customer.customerAddress
      }

      //Data do pedido
      const date = new Date(this.order.createdAt)
      this.dateOrder = this.datePipe.transform(date, `dd/MM/yyyy HH:mm`);

      //Caso o status seja aguardando pagamento
      if(this.order.orderStatus == 9)
      {
        this.intervalId = setInterval(() => {
          this.getStatusOrder()
        }, 10000)
      }

      //Valida se o Pedido é um pedido agendado e se já está em produção
      if(this.order.scheduled && (this.order.orderStatus == 1 || this.order.orderStatus == 2)){
        if(this.validDate()){
          this.order.production = true;
          console.log('O pedido está em produção')
        }
        else{
          this.order.production = false;
          this.validSchedules();
        }
      }
      else{
        this.order.production = true;
      } 

      //Valida se o pedido tem desconto
      if(this.order.discounts.length != 0)
      {
        this.discount = Number(this.order.discounts[0].discountValue)
      }

    })
  }

  //Valida a cada 10 segundos se o pedido pix foi pago
  getStatusOrder(){
    this.apiService.getStatusOrder(this.order.id_order.toString()).subscribe(
      (data) =>{
        if(data.status == 2){
          clearInterval(this.intervalId)
          this.toastr.clear();
          this.toastr.success('Pagamento Confirmado.', 'Sucesso', { positionClass: 'toast-top-right', timeOut: 4000});
          this.order.orderStatus = 1
        }
        else if(data.status != 1){
          clearInterval(this.intervalId)
          this.order.orderStatus = 10;
          this.toastr.clear();
          this.toastr.warning('Tempo de pagamento expirado!', 'Pix expirado!', { positionClass: 'toast-top-right', timeOut: 4000});
        }
      },
      (error) =>{console.log(error);}
    )
  }

  //Valida a cada 5 segundos se o pedido agendando está em preparo pela loja
  validSchedules(){
    this.intervalId = setInterval(async() => {
      if(await this.validDate()){
        this.order.production = true;
        console.log('O pedido está em produção')
      }
      else{
        console.log('O pedido não está em produção')
      }
    }, 5000)
  }

  //Valida a data do pedido agendadado com a data do servidor
  validDate(){
    const dateServer = new Date(this.currentDate);
    const dateReceipt = new Date(this.order.scheduledReceipt);
    return dateReceipt < dateServer;
  }

  //Resgata o horário do servidor
  getDataServer(){
    this.apiService.getHours().subscribe(
      (data) =>{

        const formatted = format(new Date(data.date), 'dd-MM-yyyy HH:mm');
        console.log('Horário do Servidor', formatted);

        this.serverDate = new Date(data.date);
        this.currentDate = new Date(this.serverDate);

        this.timerId = setInterval(() => {
          this.currentDate = new Date(this.currentDate.getTime() + 1000);
        }, 1000);
      },
      (error) =>{
        console.log(error);
      }
    )
  }

  //Valida o pedido para apresentar o tempo de de preparo
  shouldShowTimeAwait(order: any): boolean {
    const isRelevantStatus = [1, 2, 3, 4].includes(order.orderStatus);

    if (!isRelevantStatus){
      return false;
    }
      
    // Se for status 1, verifica o autoCancel
    if (order.orderStatus === 1 && this.company.configs.autoCancel === 1 && !order.scheduled) {
      return false;
    }
    
    if(order.orderStatus == 1 && this.company.configs.autoCancel === 1 && order.scheduled && order.production)
    {
      return false;
    }

    return true;
  }

  //Valida as propriedades para o counter
  shouldShowCounter(order: any): boolean {
    if (!order) return false;

    // Garante que só mostra se o pedido está ativo (status 1)
    if (order.orderStatus !== 1) return false;

    // Pedido comum (não agendado)
    if (!order.scheduled) return true;

    // Pedido agendado com produção iniciada
    if (order.scheduled && order.production) return true;

    return false;
  }

  //Redireciona para o pagamento não finalizado tanto cartão quanto pix
  finalizarPagamento(order: Order) {
    const link = order.paymentForm?.[0]?.linkCheckout;

    if (link) {
      window.location.href = link;
    } else {
      console.error('Link de pagamento não encontrado.');
    }
  }

  calcSubTotal(){
    const totalPedido = this.order.items.reduce((total, item) => {
      return total + Number(item.totalPrice);
    }, 0);

    if(this.order.discounts && this.order.discounts.length > 0 && this.order.discounts[0].couponType == 2){
      return totalPedido + Number(this.order.discounts[0].discountValue);
    }

    return totalPedido;
  }
}
